// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-carousel__item h3{color:#475669;font-size:14px;opacity:.75;line-height:200px;margin:0}.el-carousel__item:nth-child(2n){background-color:#99a9bf}.el-carousel__item:nth-child(odd){background-color:#d3dce6}", ""]);
// Exports
module.exports = exports;
